<nz-header>
  <div class="inner-header">
    <div class="logo">
      <a href="https://doctorbusiness.ro">
        <img src="/assets/img/LOGO_DB_logo&tag_white-2022.svg" />
      </a>
    </div>

    <ul id="menu-expand" (click)="toggleField()" [class.toggled]="classToggled">
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <ul [class.toggled]="classToggled" nz-menu nzTheme="light" nzMode="inline">
      <li nz-menu-item>
        <a class="nav-item nav-link" href="https://doctorbusiness.ro" (click)="toggleField()">Acasă</a>
      </li>
      <!-- <li nz-menu-item *ngIf="!currentUser">
        <a class="nav-item nav-link" href="https://doctorbusiness.ro/cat-costa/" (click)="toggleField()">Cât costă?</a>
      </li> -->

      <!-- <li nz-menu-item *ngIf="!currentUser" nzMatchRouter><a class="nav-item nav-link" routerLink="/login">Login</a></li> -->
      <!-- <li nz-menu-item *ngIf="!currentUser" nzMatchRouter><a class="nav-item nav-link" routerLink="/register">Register</a></li> -->

      <li nz-menu-item nzMatchRouter *ngIf="currentUser">
        <a class="nav-item nav-link" routerLink="/pay" (click)="toggleField(); goTop()">Preţuri şi Produse</a>
      </li>

      <!-- *ngIf="currentUser" -->
      <li nz-menu-item *ngIf="!currentUser">
        <a class="nav-item nav-link" href="https://doctorbusiness.ro/cumpara/" (click)="toggleField()">Preţuri şi Produse</a>
      </li>
      <li nz-menu-item nzMatchRouter >
        <a class="nav-item nav-link" routerLink="/upload" (click)="toggleField(); goTop()">Încarcă balanţa</a>
      </li>
      <!-- <li
                    nz-menu-item
                    *ngIf="currentUser"
                    nzMatchRouter
                >
                    <a
                        class="nav-item nav-link"
                        routerLink="/files"
                    >
                        Balanţe
                    </a>
                </li> -->

      <!-- <li
                    nz-menu-item
                    *ngIf="currentUser && currentUserInfo.role == 'user'"
                    nzMatchRouter
                >
                    <a
                        class="nav-item nav-link"
                        routerLink="/tranzactii"
                    >
                        Tranzactii
                    </a>
                </li> -->

      <li nz-menu-item *ngIf="!currentUser">
        <a class="nav-item nav-link" href="https://doctorbusiness.ro/blog" (click)="toggleField()">Blog</a>
      </li>
      <!-- <li nz-menu-item> -->
      <!--   <a class="nav-item nav-link" href="https://doctorbusiness.ro/testimoniale" (click)="toggleField()">Testimoniale</a> -->
      <!-- </li> -->
      <!-- <li nz-menu-item>
                <a
                    class="nav-item nav-link"
                    href="https://doctorbusiness.ro/contact"
                    (click)="toggleField()"
                >
                    Contact
                </a>
            </li> 
                        nzTitle="Salut, {{currentUser.firstname}}"

        -->

      <li nz-menu-item *ngIf="currentUser" nzMatchRouter>
        <a class="nav-item nav-link" routerLink="/files" (click)="toggleField(); goTop()">Rapoarte financiare</a>
      </li>

      <li nz-menu-item *ngIf="currentUser" nzMatchRouter>
        <a class="nav-item nav-link" routerLink="/buget" (click)="toggleField(); goTop()">Buget</a>
      </li>

      <li nz-menu-item *ngIf="currentUser" nzMatchRouter>
        <a class="nav-item nav-link" routerLink="/tranzactii" (click)="toggleField(); goTop()">Facturi şi plăţi</a>
      </li>

      <li nz-menu-item *ngIf="currentUser && currentUserInfo.role == 'admin'">
        <a class="nav-item nav-link" routerLink="/users" (click)="toggleField(); goTop()">Utilizatori</a>
      </li>

      <li nz-menu-item *ngIf="currentUser && currentUserInfo.role == 'admin'">
        <a class="nav-item nav-link" routerLink="/abonamente" (click)="toggleField(); goTop()">Abonamente</a>
      </li>

      <li nz-menu-item *ngIf="currentUser && currentUserInfo.role == 'admin'">
        <a class="nav-item nav-link" routerLink="/edit" (click)="toggleField(); goTop()">Editare</a>
      </li>

      <li nz-menu-item *ngIf="currentUser">
        <a class="nav-item nav-link" routerLink="#" (click)="logout()" (click)="toggleField(); goTop()">Deconectare</a>
      </li>

      <!-- <li
                nz-submenu
                nzTitle="Contul meu"
                nzIcon="user"
                *ngIf="currentUser"
            >
                <ul>
                    <li
                        nz-menu-item
                        nzMatchRouter
                    >
                        <a
                            class="nav-item nav-link"
                            routerLink="/files"
                            (click)="toggleField(); goTop()"
                        >
                            Rapoarte financiare
                        </a>
                    </li>
                    <li
                        nz-menu-item
                        nzMatchRouter
                    >
                        <a
                            class="nav-item nav-link"
                            routerLink="/tranzactii"
                            (click)="toggleField(); goTop()"
                        >
                            Facturi şi plăţi
                        </a>
                    </li>
                    <li
                        nz-menu-item
                        *ngIf="currentUser && currentUserInfo.role == 'admin'"
                        nzMatchRouter
                    >
                        <a
                            class="nav-item nav-link"
                            routerLink="/users"
                            (click)="toggleField(); goTop()"
                        >
                            Utilizatori
                        </a>
                    </li>
                    <li
                        nz-menu-item
                        *ngIf="currentUser && currentUserInfo.role == 'admin'"
                        nzMatchRouter
                    >
                        <a
                            class="nav-item nav-link"
                            routerLink="/edit"
                            (click)="toggleField(); goTop()"
                        >
                            Editare
                        </a>
                    </li>
                    <li
                        nz-menu-item
                        (click)="logout()"
                        (click)="toggleField(); goTop()"
                    >
                        Deconectare
                    </li>
                </ul>
            </li> -->
      <li nz-menu-item *ngIf="!currentUser" nzMatchRouter>
        <a class="nav-item nav-link" routerLink="/authentification" (click)="toggleField(); goTop()">Autentificare/Înregistrare</a>
      </li>
    </ul>
  </div>
</nz-header>

<nz-content>
  <!-- <nz-breadcrumb>
      <nz-breadcrumb-item>Home</nz-breadcrumb-item>
      <nz-breadcrumb-item>List</nz-breadcrumb-item>
      <nz-breadcrumb-item>App</nz-breadcrumb-item>
    </nz-breadcrumb> -->

  <div class="inner-content">
    <router-outlet></router-outlet>
  </div>
</nz-content>

<nz-footer>
  <div class="footer-wrapper">
    <div nz-row class="footer">
      <div nz-col nzSpan="9" nzOffset="3">
        <ul>
          <li>
            <a href="https://doctorbusiness.ro/contact">Contact</a>
          </li>
          <li>
            <a href="https://doctorbusiness.ro/politica-de-retur-anulare">Politica de retur/anulare</a>
          </li>
          <li>
            <a href="https://doctorbusiness.ro/politica-de-livrare-a-serviciilor">Politica de livrare a serviciilor</a>
          </li>
          <li>
            <a href="https://doctorbusiness.ro/politica-de-confidentialitate">Politica de confidenţialitate</a>
          </li>
          <li>
            <a href="https://doctorbusiness.ro/termeni-si-conditii">Termeni şi condiţii</a>
          </li>
          <li>
            <a href="https://anpc.ro/">ANPC</a>
          </li>
        </ul>
      </div>
      <div nz-col nzSpan="9">
        <img src="/assets/img/LOGO_DB_logo&tag_white-2022.svg" />
        <img src="/assets/img/netopia_bannerArtboard-1-100.jpg" />
      </div>
    </div>
    <!-- <div
            nz-row
            class="footer-credits"
        >
            <div
                nz-col
                nzSpan="18"
                nzOffset="3"
            >
                The Doctor of your Business ©2021 Powered By Ebit
            </div>
        </div> -->
  </div>
</nz-footer>

<button class="top-page" (click)="goTop()" [class.show]="scrollTop"></button>

<!-- <ng-container *ngIf="cookieBar"> -->
<!--   <div id="cookie-notice"> -->
<!--     Acest site folosește "cookies". Navigând în continuare, vă exprimați acordul asupra folosirii acestora. Vezi -->
<!--     <a href="https://doctorbusiness.ro/politica-de-confidentialitate">politica cookie</a> -->
<!--     . -->
<!--     <button nz-button nzType="primary" (click)="cookieConsent()">Ok</button> -->
<!--   </div> -->
<!-- </ng-container> -->
